import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { UtilsService } from '../utils/utils.service';

@Injectable({
	providedIn: 'root',
})
export class BillingService {
	constructor(
		private http: HttpClient,
		private utils: UtilsService,
	) {}

	getAllPayed(start_date: string, end_date: string) {
		const url = `${environment.api}billing/${start_date}/${end_date}/get_all_payed`;
		return this.http.get(url);
	}

	getNotPayedLeads() {
		const url = `${environment.api}billing/all_approved_not_payed`;
		return this.http.get(url);
	}

	chargeLead(payload) {
		const url = `${environment.api}billing/charge_lead`;
		const formData: any = this.utils.jsonToFormData(payload);
		return this.http.post(url, formData);
	}

	getCusIdFromNMI(email: string) {
		const url = `${environment.api}payments/nmi/${email}/get_cus_id`;
		return this.http.get(url);
	}

	linkNmiCustomer(email: string, customer_id: string) {
		const formData: any = this.utils.jsonToFormData({ email, customer_id });
		const url = `${environment.api}payments/nmi/link_customer`;
		return this.http.post(url, formData);
	}

	getDefaultPaymentMethod(cus_id: string) {
		const url = `${environment.api}payments/nmi/${cus_id}/get_user_default_payment`;
		return this.http.get(url);
	}

	addNewCard(payload) {
		const formData: any = this.utils.jsonToFormData(payload);
		const url = `${environment.api}payments/nmi/add_new_card`;
		return this.http.post(url, formData);
	}

	setAsFree(payload) {
		const url = `${environment.api}billing/set_as_free`;
		const formData: any = this.utils.jsonToFormData(payload);
		return this.http.post(url, formData);
	}

	setAsPayed(payload) {
		const url = `${environment.api}billing/set_payed`;
		const formData: any = this.utils.jsonToFormData(payload);
		return this.http.post(url, formData);
	}

	undoPayment(payload) {
		const url = `${environment.api}billing/undo_payment`;
		const formData: any = this.utils.jsonToFormData(payload);
		return this.http.post(url, formData);
	}

	getBillingReport(from?: string | null, to?: string | null) {
		let url = `${environment.api}billing/billing_report`;

		const params: string[] = [];
		if (from) params.push(`from=${from}`);
		if (to) params.push(`to=${to}`);
		if (params.length) url += `?${params.join('&')}`;

		return this.http.get(url);
	}

	getCampaignRevenue(payload: any) {
		const formData: any = this.utils.jsonToFormData(payload);
		const url = `${environment.api}billing/getCampaignRevenue`;
		return this.http.post(url, formData);
	}
}
